import { Button, Spinner } from "reactstrap";
import apiService from "services/api";
import { useState } from "react";
import { firstDay, lastDay } from "utils/dateHelper";
import { useQuery } from "react-query";
import { fileResponseDownloader } from "utils/fileResponseDownloader";
import { ReportSelectionCard } from "components";
import moment from "moment";

const initialState = {
	date_from: firstDay(undefined, "absolute_month"),
	date_to: lastDay(undefined, "absolute_month"),
	staff: undefined,
	grouped: false,
};

const apiCallMapper = {
	partTimeWageReport: apiService.report.partTimeWageReport,
};

const LoadingButton = ({ children, disabled, ...props }) => (
	<Button {...props} size="sm" disabled={disabled}>
		<small>
			<b>{disabled ? <Spinner size="sm" /> : children}</b>
		</small>
	</Button>
);

const PartTimeWageReportPage = () => {
	const [filterOptions, setFilterOptions] = useState(initialState);
	const [yearMonthFilterOptions, setYearMonthFilterOptions] = useState({ year: new Date().getFullYear(), month: 1 });
	const [loading, setLoading] = useState(false);

	const { data: staffOptions } = useQuery(
		["teacher"],
		() =>
			apiService.staff.get(undefined, { show_deactivated: true }).then((staffs) =>
				staffs.map((staff) => ({
					value: staff.id,
					label: staff.fullName,
				}))
			),
		{ refetchOnWindowFocus: false }
	);

	const handleChange = (e) => {
		if (!moment(e.target.value, "YYYY-MM-DD", true).isValid()) return;
		return setFilterOptions((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};

	const transformParams = () => {
		const date_from = new Date(filterOptions.date_from).toISOString().slice(0, 10);
		const date_to = new Date(filterOptions.date_to).toISOString().slice(0, 10);
		const staff_id = filterOptions.staff?.value;
		return {
			staff_id,
			date_from,
			date_to,
			grouped: filterOptions.grouped,
			...yearMonthFilterOptions,
		};
	};

	const triggerDownload = (type) => {
		setLoading(true);
		let fileName = `report_${filterOptions.date_from}_${filterOptions.date_to}.csv`;
		if (type === "partTimeWageReport") fileName = `${filterOptions.date_from}_${filterOptions.date_to}_part_time_wage_resources.zip`;
		apiCallMapper[type](transformParams(), filterOptions.grouped)
			.then((data) => {
				fileResponseDownloader({ fileName, data });
			})
			.finally(() => setLoading(false));
	};

	return (
		<div className="content">
			<div className="row">
				<ReportSelectionCard
					title="Part Time Wage Report"
					handleChange={handleChange}
					filterOptions={filterOptions}
					setFilterOptions={setFilterOptions}
					buttons={
						<>
							<LoadingButton color="info" className="mr-2" disabled={loading} onClick={() => triggerDownload("partTimeWageReport")}>
								Generate
							</LoadingButton>
						</>
					}
				/>
			</div>
		</div>
	);
};

export default PartTimeWageReportPage;
